<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">BANK FINANCE</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-flex xs12 md12>
              <v-select
                class="mx-2"
                v-model="car"
                dense
                outlined
                label="Bank"
                :items="car_items"
                item-value="id"
                item-text="name"
                :rules="rules.combobox_rule"
              ></v-select>
            </v-flex>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{ alert_message }}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

import {mdiAlertOutline} from "@mdi/js";
import {mapActions, mapGetters} from "vuex";

const initialState = () => {
  return {
    saving_request: false,
    alert: false,
    alert_message: '',
    particulars: '',
    date: '',
    car: '',
    car_items: [],
    details: '',
    category_idd: '',
    details_items: [],
    category_items: [],
    description: '',

    isLoading: false,
  }
}
export default {
  props: {
    is_liquidation: Boolean,
    category_id: Number,
    branch_id: Number,
    particulars_id: Number,
    particulars_data_id: Number,
    particulars_description_items: Array,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
      },
    }
  },
  data() {
    return initialState();
  },
  mounted() {
    this.list_of_bank_finance_to_request()
      .then(response => {
        this.car_items = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
  },
  methods: {
    ...mapActions('bank_finance', ['list_of_bank_finance_to_request',]),
    done_request() {
      this.saving_request = true
      this.alert = false
      if (this.$refs.form.validate()) {
        var index = this.car_items.map(function (x) {
          return x.id;
        }).indexOf(this.car)
        if (index != -1) {
          let details = this.car_items[index]
          this.$emit('data', 'ID-' + details.id + ' # Bank-' + details.name)
          this.$emit('amount', parseFloat(details.total) )
        }
        this.saving_request = false
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving_request = false
      }
    },
  }
}
</script>
